import t from "./_arrayPush.js";
import l from "./isArray.js";
var u = t, y = l;
function i(r, s, e) {
  var a = s(r);
  return y(r) ? a : u(a, e(r));
}
var o = i;
export {
  o as default
};
//# sourceMappingURL=_baseGetAllKeys.js.map
